const ticket = {
    id: 1,
    createdBy: {
        id: 1,
        firstName: "John",
        lastName: "Doe"
    },
    createdDate: "18-12-2022 08:59",
    startDate: "10-10-2023 10:10",
    endDate: "",
    status: "InProgress",
    ticketOperations: [
        {
            id: 1,
            name: "Curățare și verificare",
            startDate: "10-10-2023 10:10",
            endDate: "10-10-2023 11:11",
            status: "Resolved"
        },
        {
            id: 2,
            name: "Măsurători",
            startDate: "10-10-2023 12:12",
            endDate: null,
            status: "InProgress"
        },
        {
            id: 3,
            name: "Regravare",
            startDate: null,
            endDate: null,
            status: "New"
        }
    ]
}

export default ticket;
